export const config = {
  id: 'product-manager',
  icon: 'Target',
  color: 'blue',
  title: 'Product Manager',
  description: 'Product strategy, roadmap planning, and cross-functional team leadership',
  department: 'Product',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 5,
    mid: 4,
    senior: 3
  }
};
